import {
  getUser
} from "./chunk-P6XMZV77.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/auth/user.ts
import { useQuery } from "@tanstack/react-query";
var useGetUser = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["user", props],
    queryFn: () => getUser(props)
  }, options));
};

export {
  useGetUser
};
//# sourceMappingURL=chunk-LUMF4NRH.mjs.map